<template>
  <form ref="form" @submit.prevent="handleSubmit">
    <v-container fluid class="main">
      <v-row>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row>

              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer Type ( <span style="color: #039DE9;">Automatic *</span> )</legend>
                  <v-text-field
                    label="Crypto Transfer"
                    disabled
                    placeholder="Crypto Transfer"
                    single-line solo hide-details readonly
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <!-- Crypto Network: readonly, pre-filled from OvyPayNetworkForm -->
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Crypto Network</legend>
                  <v-text-field
                    :value="selectedNetworkName"
                    single-line solo hide-details readonly
                    class="custom-select"
                    append-icon="mdi-lock-outline"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Deposit to</legend>
                  <v-select
                    v-model="selectedAccount"
                    :items="formattedAccounts"
                    item-text="display"
                    item-value="trading_account_no"
                    solo append-icon="mdi-chevron-down"
                    label="Select One"
                    class="custom-select"
                    hide-details
                    @change="handleAccountChange"
                  ></v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" :md="currency.name !== 'USD' ? 6 : 12">
                <fieldset>
                  <legend>Amount in (USD)</legend>
                  <v-text-field
                    v-model="depositAmount"
                    label="$"
                    type="number"
                    single-line solo hide-details
                    class="custom-select"
                    min="1"
                    :rules="[rules.required, rules.minAmount]"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6" v-if="currency.name !== 'USD'">
                <fieldset>
                  <legend>Amount in <span :style="{ color: currency.color }">({{ currency.name }})</span></legend>
                  <v-text-field
                    readonly
                    v-model="currencyAmount"
                    :label="currency.symbol"
                    type="number"
                    single-line solo hide-details
                    class="custom-select text-muted"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-btn
                  type="submit" tile elevation="0"
                  class="ma-0 text-capitalize btn-account d-block"
                  color="greenMain"
                  :loading="loading"
                  :disabled="!isFormValid || loading"
                >
                  Proceed Payment
                </v-btn>
              </v-col>

            </v-row>
          </v-card>
        </v-col>

        <v-col lg="6" md="6" sm="12" cols="12" class="crypto-div">
          <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row>
              <v-card-title class="title px-0 py-0 ml-3 mt-3">Instructions:</v-card-title>
              <ol class="instruction">
                <li>Scan the QR code or copy the wallet address displayed on the payment page to complete your deposit.</li>
                <li>The wallet address is valid for <strong>15 minutes</strong> only. Please complete your transfer before it expires.</li>
                <li><strong>Minimum deposit amount is $50.</strong> Deposits below this amount will not be processed.</li>
                <li>Transfers from <strong>third-party wallets</strong> or exchanges are not accepted. The sender's name must match the registered account holder's name.</li>
                <li>Network fees are charged by the blockchain. Ensure the exact deposit amount (excluding network fee) reaches the address.</li>
                <li>After the payment is sent, the system will automatically detect and verify your transaction — no need to upload a receipt.</li>
                <li>If your deposit does not appear after confirmation, please contact support with your <strong>transaction ID (TXID)</strong>.</li>
              </ol>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- Payment Dialog -->
      <v-dialog v-model="paymentDialog" max-width="450px">
        <v-card :color="$vuetify.theme.dark ? '#131c29' : 'white'" class="pb-4">
          <v-img height="120" contain src="@/assets/payments/ovyPay.png"></v-img>

          <v-card-title class="headline font-weight-bold">
            <v-progress-circular size="25" class="mr-3" indeterminate color="#039ce952"></v-progress-circular>
            Payment is processing...
          </v-card-title>

          <v-card-text>
            <p class="mt-3 mb-0 text-center">Your crypto deposit session has been created successfully.</p>
          </v-card-text>

          <v-card-text class="text-center">
            Please make payment on OvyPay gateway and wait for confirmation.
          </v-card-text>

          <!-- Callback URL for verification -->
          <!-- <v-card-text class="pt-0">
            <p class="caption text--secondary mb-1">Callback URL:</p>
            <small style="color: #039DE9; word-break: break-all;">{{ callbackUrl }}</small>
          </v-card-text> -->

          <v-card-actions class="justify-end">
            <v-btn @click="paymentDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CRYPTO__ACTIONS, DEPOSITMETHODS__ACTIONS, PROFILE__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  name: 'CryptoDepositFormOvyPay',

  data() {
    return {
      paymentDialog: false,
      gatewayLink: "",
      payment_id: null,

      selectedNetwork: null,
      selectedNetworkName: null,

      selectedAccount: null,
      orderId: null,
      depositAmount: '',
      currencyAmount: '',
      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color: "#fff"
      },
      loading: false,

      rules: {
        required: value => !!value || 'This field is required',
        minAmount: value => value > 0 || 'Amount must be greater than 0',
      },
    };
  },

  computed: {
    ...mapState("crypto", ["ovypaycrypto", "ovypayClientUrl"]),
    ...mapState("deposit", ["accounts"]),
    ...mapState("profile", ["client"]),

    formattedAccounts() {
      return this.accounts.map(account => ({
        display: `${account.trading_account_no} (${account.account_type_display}) ${account.Balance} ${account.currency_name}`,
        trading_account_no: account.trading_account_no,
        ...account,
      }));
    },

    selectedAccountObj() {
      return this.accounts.find(acc => acc.trading_account_no === this.selectedAccount) || null;
    },

    isFormValid() {
      return !!(this.selectedAccountObj && this.selectedNetwork && this.depositAmount >= 50);
    },

    callbackUrl() {
      const base = this.ovypayClientUrl || '';
      return `${base}/api/ovypay/deposit/callback`;
    },
  },

  watch: {
    depositAmount(newAmount) {
      if (this.currency && this.currency.rate) {
        this.currencyAmount = (newAmount * this.currency.rate).toFixed(2);
      } else {
        this.currencyAmount = newAmount;
      }
    },
  },

  methods: {
    ...mapActions("crypto", [CRYPTO__ACTIONS.OVYPAY]),
    ...mapActions("profile", [PROFILE__ACTIONS.GETPROFILE]),
    ...mapActions("deposit", [
      DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS,
      DEPOSITMETHODS__ACTIONS.PAYMENTNOTIFICATION,
      DEPOSITMETHODS__ACTIONS.PAYMENTLOG,
      DEPOSITMETHODS__ACTIONS.CREATECRYPTODEPOSITOVIPAYQR,
    ]),

    handleAccountChange() {
      // ✅ FIX: Do NOT call this.$refs.form.reset() here.
      // form.reset() wipes ALL v-model fields including selectedNetwork,
      // selectedNetworkName, and selectedAccount — causing the network
      // field to go blank and account selection to reset.
      // Instead, manually reset only the amount fields.
      this.depositAmount  = '';
      this.currencyAmount = '';

      const account_details = this.accounts.find(
        acc => acc.trading_account_no === this.selectedAccount
      );
      if (account_details) {
        this.currency.rate   = account_details.currency_rate;
        this.currency.name   = account_details.currency_name;
        this.currency.symbol = account_details.currency_symbol;
        this.currency.color  = account_details.symbol_color;
      }
    },

    async handleSubmit() {
      try {
        this.loading = true;
        this.orderId = `OvyPay-${Date.now()}-${Math.random().toString(36).substring(2, 8)}`;

        // Ensure profile is loaded
        if (!this.client || !this.client.fname) {
          await this[PROFILE__ACTIONS.GETPROFILE]();
        }

        const clientName = [this.client?.fname, this.client?.lname]
          .filter(Boolean)
          .join(' ')
          .trim();

        const payload = {
          amount_usd:        parseFloat(this.depositAmount),
          customer_email:    this.client?.email || '',
          customer_name:     clientName,
          merchant_order_id: this.orderId,
          callback_url:      this.callbackUrl,
          payment_type:      this.selectedNetwork,
        };

        const res = await this[DEPOSITMETHODS__ACTIONS.CREATECRYPTODEPOSITOVIPAYQR](payload);
        await this[DEPOSITMETHODS__ACTIONS.PAYMENTNOTIFICATION](res);

        if (res && res.deposit_address) {
          await this[DEPOSITMETHODS__ACTIONS.PAYMENTLOG]({
            email:              this.client?.email,
            payment_type:       this.selectedNetwork,
            gateway:            'OvyPay',
            payment_system_id:  this.payment_id,
            amount:             this.depositAmount,
            wallet_address:     res.deposit_address,
            trading_account_no: this.selectedAccount,
            transactionId:      res.merchant_order_id || this.orderId,
            gateway_order_id:   res.gateway_order_id || '',
          });

          if (res.payment_link) window.open(res.payment_link, "_blank");
          this.paymentDialog = true;

          setTimeout(() => {
            this.resetForm();
            this.$router.push("/wallet");
          }, 15000);

        } else {
          toast.error("Failed to generate deposit address. Please try again.");
        }

      } catch (error) {
        console.error("Deposit submission error:", error);
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.$nextTick(() => {
        this.depositAmount       = '';
        this.currencyAmount      = '';
        this.orderId             = null;
        this.paymentDialog       = false;
        this.gatewayLink         = "";
        this.selectedAccount     = null;
        this.selectedNetwork     = null;
        this.selectedNetworkName = null;
        if (this.$refs.form) this.$refs.form.reset();
      });
    },
  },

  async mounted() {
    try {
      this.payment_id          = this.$route.query.payment_id;
      this.selectedNetwork     = this.$route.query.network      || null;
      this.selectedNetworkName = this.$route.query.network_name || this.selectedNetwork;

      await this[DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS]();
    } catch (error) {
      console.error('Failed to fetch initial data:', error);
    }
  },

  async created() {
    await Promise.all([
      this[CRYPTO__ACTIONS.OVYPAY](),
      this[PROFILE__ACTIONS.GETPROFILE](),
    ]);
  },
};
</script>

<style>
.main {
  height: 100vh !important;
  overflow-y: scroll;
  margin: 0;
}

.crypto-div {
  min-height: 380px;
}

.colormain {
  color: #039DE9;
}

strong {
  color: #039DE9;
}

.instruction li {
  margin: 10px 0;
}
</style>